var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { MOCK_USER } from "./data/dev-user";
import { AuthContext } from "react-oidc-context";
export var AuthDevMockProvider = function (_a) {
    var children = _a.children;
    var mockAuthState = useMemo(function () {
        var user = {
            user: MOCK_USER,
            isLoading: false,
            error: null,
            isAuthenticated: true,
            events: {
                addSilentRenewError: function (cb) {
                    cb.call(user, user.error);
                },
            },
            // Методы заглушки (не делают запросов)
            signinRedirect: function () { return Promise.resolve(); },
            signoutRedirect: function () { return Promise.resolve(); },
            signinSilent: function () { return Promise.resolve(MOCK_USER); },
            removeUser: function () { return Promise.resolve(); },
            revokeTokens: function () { return Promise.resolve(); },
        };
        return user;
    }, []);
    return (_jsx(AuthContext.Provider, __assign({ value: mockAuthState }, { children: children })));
};
